export default "__VITE_ASSET__DWAKPWrD__"